import React, { Component } from 'react';
import SGDropDown from 'Common/SGDropDown/SGDropDownEx.js';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import pako from 'pako';

import { ConvToString, ConvToInt, ConvToBool } from 'Common/utilsEx.js';

export default class BranchSelectionForm extends Component {


    constructor(props) {
        super(props);

        this.state =
        {
            disableLocationDropdownList: false,

            disableButtons: false,
            enableLoader: false,
			ErrMsg:"",
			PreparingToLoad:false,
			forceDisable:true,
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {

    }
	componentDidMount() {
		this.showLoginDetailsWindow();
	}

    render() {


        let userRole = <div>{this.UserRoleDisabled()}</div>;
        let userCompany = <div>{this.UserCompanyDisabled()}</div>;
        let userBranch = <div>{this.UserBranchDisabled()}</div>;

        if (this.props.Screen.showLoginDiv)
            userRole = <div>{this.UserRoleVisible()}</div>;
        if (this.props.Screen.showProceedDiv) {
            userCompany = <div>{this.UserCompanyVisible()}</div>;
            userBranch = <div>{this.UserBranchVisible()}</div>;

            userRole = <div>{this.UserRoleVisible()}</div>;
        }

        let userSubmit = <div>{this.UserSubmitDisabled()}</div>;
        if (this.props.Screen.showNewPwdDiv) {
            userCompany = <div></div>;
            userBranch = <div></div>;
            userRole = <div></div>;
            userSubmit = <div></div>;
        }
		let otpClasses = "userid1 "+(this.state.enableLoader?"ddldisabled":"");
        let OTPEntry = <div> <input style={{ borderRadius: '5px', borderColor:'#d3d3d3', height: '2rem', fontSize:'14pt', paddingLeft:'10px', backgroundColor:'inherit',letterSpacing:'5px' }} id="txtOTP" ref="txtOTP" type='text' className={otpClasses}
                        placeholder="OTP" maxLength="15" autoComplete="off" disabled={this.state.enableLoader}  />
					</div>

            return (
                <div className="form2">
					<div style={{ color: '#188DB2', marginBottom : '18px',fontSize: '1.5em' }}>Hi {this.props.UserDetails.userName},</div>

                    <form onSubmit={(e) => e.preventDefault()}
                        onKeyPress={(event) => this.onProceedFormKeyPress(event)} method="post">
                        <div>{userRole}</div>
                        <div>{userCompany}</div>
                        <div className="select-overall">
                            <div className="form-group">{userBranch}</div>
                        </div>
						{this.props.Enable2FactorAuth?.toLowerCase() == "true" && (this.props.Screen.mfaRegistered || this.props.Screen.RegisterMFA) && OTPEntry}
						
						<div style={{ textAlign: "left", color:'red' }}><span >{(this.state.ErrMsg.length > 0) ? this.state.ErrMsg : ""}</span></div>
                        <div className="row1">
                            <div className="row-1" style={{ marginTop: "35px" }}>{userSubmit}</div>
                        </div>

                    </form>
                </div>
				
            )
    }


    /* user role start */

    UserRoleDisabled() {
        return (<div className="select-overall">
            <select type="select" className="userid" placeholder="Select Role" disabled defaultValue="">
                <option value="">Select Role</option>
            </select>
        </div>
        );
    }

    UserRoleInvisibleBranchAdmin() {
        return (<div className="select-overall">
            <hr className="hr-padding logo-hr1" />
            <p className="p-padding"> Branch Administrator </p>
            <hr className="hr-padding logo-hr1" />
        </div>);
    }

    UserRoleInvisibleUser(userRoleId) {
        let userRoleIdStr = "User";
        switch (userRoleId) {
            case 'user': userRoleIdStr = "User"; break;
            case 'admin': userRoleIdStr = "Branch Administrator"; break;
            case 'coadm': userRoleIdStr = "Company Administrator"; break;
            case 'global': userRoleIdStr = "Global"; break;
        }
        return (<div className="select-overall">
            <hr className="hr-padding logo-hr1" />
            <p className="p-padding"> {userRoleIdStr} </p>
            <hr className="hr-padding logo-hr1" />
        </div>);
    }
    isNotCompOrSysAdmin() {
        let userRoleId = String(this.props.UserDetails.userRoleId).toLowerCase();
        return (userRoleId == 'user' || userRoleId == 'admin' || userRoleId == 'global')

    }
    UserRoleVisible() {
        if ((!this.props.Screen.showProceedDiv)) {
            return this.UserRoleDisabled();
        }
        let userRoleId = String(this.props.UserDetails.userRoleId).toLowerCase();
        if (userRoleId == 'user' || userRoleId == 'admin' || userRoleId == 'global') {
            return this.UserRoleInvisibleUser(userRoleId);
        }
        let adminText = (userRoleId == 'coadm' ? "Company " : "System ") + "Administrator";
        let RoleList = [{ value: "1", text: "Branch Administrator" },
        { value: "2", text: adminText }
        ];
        return (
            <div className="select-overall">
                <SGDropDown
                    id="ddlRole"
                    placeholder={"Select Role"}
                    options={RoleList}
                    label="text"
                    value="value"
                    className=" userid5"

                    
                    disabled={this.state.enableLoader || (!this.props.Screen.showProceedDiv)}
                    selectedValue={this.props.UserDetails.UserRoleVal}
                    onChange={(item) => this.handleRoleSelect(item)}
                    onKeyPress={(event) => this.onRoleKeyPress(event)}
                    style={{
                        color: (this.IsAdmin() ? "#424242" : "#909090"), height : '20px'
                    }}
                />
            </div>
        );
    }
    handleRoleSelect(item) {

        switch (item.value) {
            case "1":
                this.props.UserDetails.UserRoleVal = 1;
                this.props.UserDetails.isSysAdmin = false;
                this.props.UserDetails.isBranchAdmin = true;
                this.setState({}); break;
            case "2":
                this.props.UserDetails.UserRoleVal = 2;
                this.props.UserDetails.isSysAdmin = true;
                this.props.UserDetails.isBranchAdmin = false;
                this.setState({}); break;
        }
    }

    onRoleKeyPress(event) {
        if (this.IsAdmin()) {
            if (event.charCode == 13) {
                event.preventDefault();
                this.onProceedButtonClick(false);
            }
        }
    }
    /* user role ends */

    /* user Company start */

    UserCompanyDisabled() {
        return (<div className="select-overall">
            <select type="select" className="userid" placeholder="Select Role" disabled defaultValue="">
                <option value="">Select Company</option>
            </select>
        </div>
        );
    }

    UserCompanyInvisible() {

        return (<div>
            <hr className="hr-padding logo-hr1" />
            <p className="p-padding"> {this.props.UserDetails.companyDtlList.length >= 1 ? this.props.UserDetails.companyDtlList[0].Name : ""} </p>
            <hr className="hr-padding hr-margin-bottom logo-hr1" />
        </div>);
    }

    onCompanyKeyPress(event) {

        if (parseInt(this.rops.UserDetails.userCompanyID) > 0) {
            if (event.charCode == 13) {
                event.preventDefault();
                this.onProceedButtonClick(false);
            }
        }
    }


    UserCompanyVisible() {
        if ((this.props.UserDetails.isSysAdmin === true || (!(this.props.UserDetails.isBranchAdmin))) && (!this.isNotCompOrSysAdmin())) {
            return this.UserCompanyDisabled();
        }

        if (this.props.UserDetails.companyDtlList.length == 1)
            return (<div style={{ display: (this.props.UserDetails.companyDtlList.length == 1 ? "" : "none") }}>
                <hr className="hr-padding logo-hr1" />
                <p style={{ padding: '9px', margin: '0px' }}> {this.props.UserDetails.companyDtlList.length == 1 ? this.props.UserDetails.companyDtlList[0].Name : ""} </p>
                <hr className="hr-padding hr-margin-bottom logo-hr1" />
            </div>)
        else {

            return (
                <div className={this.props.UserDetails.companyDtlList.length > 1 ? "select-overall" : ""}  >
                    <SGDropDown
                        id="ddlCompany"
                        options={this.props.UserDetails.companyDtlList}
                        label="Name"
                        value="CompanyID"
                        className=" userid5"
                        style={{}}
                        
                        disabled={this.state.enableLoader || ((!this.props.Screen.showProceedDiv) || (this.props.UserDetails.isSysAdmin))}
                        selectedValue={this.props.UserDetails.userCompanyID}
                        onChange={(comp) => this.selectCompany(comp)}
                        onKeyPress={(event) => this.onCompanyKeyPress(event)} />

                </div>


            );
        }
    }

    /* user Company ends */

    /* user Branch start */

    UserBranchDisabled() {
        return (<div>
            <select type="select" className=" userid" placeholder="Select Branch" disabled defaultValue="">
                <option disabled value="">Select Branch</option>
            </select>
        </div>
        );
    }
    onBranchKeyPress(event) {
        event.preventDefault();
        if (parseInt(this.props.UserDetails.userLocationId) > 0) {
            if (event.charCode == 13) {

                this.onProceedButtonClick(false);
            }
        }
    }
    UserBranchInvisible() {
        return (<div >
            <hr className="hr-padding logo-hr1" />
            <p className="p-padding-branch"> Mumbai </p>
            <hr className="hr-padding logo-hr1" />
        </div>);
    }

    UserBranchVisible() {
        if ((this.props.UserDetails.isSysAdmin === true || (!(this.props.UserDetails.isBranchAdmin))) && (!this.isNotCompOrSysAdmin())) {
            return this.UserBranchDisabled();
        }

        if (this.props.UserDetails.locationDtlList.length == 1)
            return (<div>
                <hr className="hr-padding logo-hr1" />
                <p className="p-padding-branch"> {this.props.UserDetails.locationDtlList.length == 1 ? this.props.UserDetails.locationDtlList[0].Location : ""} </p>
                <hr className="hr-padding logo-hr1" />
            </div>)
        else {

            return (

                <div className={(this.props.UserDetails.locationDtlList.length > 1) ? "select-overall" : ""} >
                    <SGDropDown
                        id="ddlLocation"
                        options={this.props.UserDetails.locationDtlList}
                        label="Location"
                        value="LocationId"
                        className=" userid5"
                        style={{}}
                        
                        selectedValue={this.props.UserDetails.userLocationId}
                        disabled={this.state.enableLoader || this.state.disableLocationDropdownList}
                        onChange={(loc) => this.selectLocation(loc)}
                        onKeyPress={(event) => this.onBranchKeyPress(event)}
                    />
                </div>
            );
        }
    }

    selectCompany(comp) {

        let companyID = parseInt(comp.value);
        this.props.UserDetails.userCompanyID = comp.value;
        this.props.UserDetails.userCompanyName = comp.label;
        this.setState({
            disableButtons: true
        });

        const userRole = String(this.props.UserDetails.userRoleId).toLowerCase();
        var isSysAdmin = userRole === 'ho' || userRole === 'coadm';
        var webMethodUrl = 'Core/Login/WebService/LoginHelper.asmx/GetCompanyDetailData';

        axios({
            url: webMethodUrl,
            method: "POST",
            data: JSON.stringify({ companyID: companyID, isSysAdmin: isSysAdmin }),
            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        })
            .then(resp => {
                var data = resp.data;
                this.setState({ disableButtons: false });
                if (data != null && String(data.d).length > 0) {
                    var htCompDtl = JSON.parse(data.d);
                    if (htCompDtl != null) {
                        let locationDtlList = [];
                        if (String(htCompDtl['LocationDetailData']).length > 0)
                            locationDtlList = JSON.parse(htCompDtl['LocationDetailData']);

                        this.props.UserDetails.locationDtlList = locationDtlList;
                        this.setDefaultLocation(false, 0);
                        this.setState({
                        });


                    }
                }
            })
            .catch(error => {
                this.setState({ disableButtons: false });
                alert('error:' + error);
            })
    }

    setDefaultLocation(setAsPerCookie, defLocation) {

        if (typeof (setAsPerCookie) == undefined || setAsPerCookie == null) setAsPerCookie = false;
        if (this.props.UserDetails.locationDtlList != null && this.props.UserDetails.locationDtlList.length > 0) {

            if (typeof (defLocation) == undefined || defLocation == null) defLocation = 0;
            if (!setAsPerCookie) {
                defLocation = 0;
            }
            let locDtl = this.props.UserDetails.locationDtlList[defLocation];
            this.props.UserDetails.userLocationId = locDtl.LocationId;
            this.props.UserDetails.userLocationName = locDtl.Location;

        }
    }



    showPaymentMsgTbl(failMsg) {
        this.props.MSG.paymentCheckMsg = failMsg;
        this.props.Screen.showPaymentMsgScreen = true;
        this.props.Parent.forceUpdate();
    }


    selectLocation(loc) {
        this.props.UserDetails.userLocationId = parseInt(loc.value);
        this.props.UserDetails.userLocationName = loc.label;
        this.setState({});
    }
    /* user Branch ends */

    /* user submit start */
    IsAdmin() {
        return (this.props.UserDetails.isSysAdmin || this.props.UserDetails.isBranchAdmin);
    }
    UserSubmitDisabled() {


        var disProceed = (!this.state.disableButtons);
        if ((this.IsAdmin() || (this.isNotCompOrSysAdmin()))) {
            disProceed = false;
        }
        else {
            disProceed = (!this.state.disableButtons);
        }
        return (<div className="headerTop-width HeaderBottom-margin-top" style={{ verticalAlign: "top" }}>
            <div className="headerBottom-width headerBottom-right-align" style={{ width: "100%" }}>
                <button
                    ref='btnPrcd'
                    className={disProceed ? "form1-bu-d" : "form1-bu"}
                    onClick={() => this.onProceedButtonClick(false)}
                    disabled={disProceed || this.state.PreparingToLoad}
                >
				{this.getProceedButtonCaption()}
                </button>
            </div>
        </div>);
    }
	getProceedButtonCaption()
	{
		if(this.state.PreparingToLoad)
			return <span>Preparing to start...<i class="fa fa-spinner fa-spin loader"></i></span>;
		if(this.state.enableLoader)
			return <span>Verifying...<i class="fa fa-spinner fa-spin loader"></i></span>;
		return "Submit";
	}
    onProceedFormKeyPress(event) {

        if (event.charCode == 13) {
            event.preventDefault();
            this.onProceedButtonClick(false);
        }

    }
    onProceedButtonClick(killSession) {
        this.setState({ disableButtons: true, enableLoader: true  }, () => {
            this.onProceedButtonClicked(killSession);
        });
    }
    getParams(killSession) {


        let isSysAdmin = this.props.UserDetails.isSysAdmin;
        if (typeof (isSysAdmin) == undefined || isSysAdmin == null || isNaN(Boolean(isSysAdmin))) isSysAdmin = false;

        let htParams = {};
        htParams['UserID'] = this.props.UserDetails.userId;

        htParams['UserCompanyID'] = isSysAdmin ? -1 : this.props.UserDetails.userCompanyID;
        htParams['UserCompanyName'] = isSysAdmin ? 'SYSADMIN' : this.props.UserDetails.userCompanyName;
        htParams['UserLocationID'] = isSysAdmin ? -1 : this.props.UserDetails.userLocationId;
        htParams['UserLocationName'] = isSysAdmin ? '' : this.props.UserDetails.userLocationName;

        htParams['UserRoleID'] = this.props.UserDetails.userRoleId;
        htParams['KillSession'] = (killSession || false);
        htParams['UserName'] = this.props.UserDetails.userName;

        return htParams;
    }

    onProceedButtonClicked(killSession) {
        let paramObj = this.getParams(killSession);

        let _data = {
            UserID: paramObj.UserID,
            CompanyID: paramObj.UserCompanyID,
            CompanyName: paramObj.UserCompanyName,
            LocationID: paramObj.UserLocationID,
            LocationName: paramObj.UserLocationName,
            UserRoleID: paramObj.UserRoleID,
            KillSession: paramObj.KillSession,
			RegisterMFA: this.props.Screen.RegisterMFA,
			OTP: '',
        };
		if(this.props.Enable2FactorAuth?.toLowerCase() == "true" && (this.props.Screen.RegisterMFA || this.props.Screen.mfaRegistered))
			_data.OTP=document.getElementById("txtOTP")?.value?.trim();
        let binaryString = pako.gzip(JSON.stringify(_data), { to: 'string' });
        let base64Data = btoa(binaryString)
		this.setState({ ErrMsg: '' });

        fetch(window.baseUrl + 'Login/ProceedClick', {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: base64Data }),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json()
            })
            .then(repdata => {
                if (repdata && repdata.Location) {
					this.setState({PreparingToLoad: true});
                    window.location = repdata.Location;
                }
				else
					this.setState({ enableLoader: false })

                if (repdata && repdata.data) {
                    this.ProceedResponse(repdata.data);

                }
            })
            .catch((error) => {
                this.setState({ disableButtons: false });
                console.error('Error:', error);
                if (error instanceof SyntaxError && error.message.includes('JSON')) {
					this.setState({ enableLoader: false })
                    alert('The server returned an empty or invalid response. Please try again.'); 
                  } else if (error.message === 'Network response was not ok' || error instanceof TypeError) {
                    alert('There was a problem connecting with the server. Please check your network connection and try again.');
                  } else {
                    alert('An unexpected error occurred. Please try again.');
                }
            });
    }
    ShowLoadingScreen() {
        window.location = window.baseUrl + 'Login/Loading';
    }
    ProceedResponse(loginInfo) {
        if (loginInfo != null) {
            switch (String(loginInfo.Action || "")) {
                case "ASKKILL":
                    {
                        this.promptForKillSession('proceed', loginInfo.ActiveLoginSource);
                    }
                    break;
                case "TOU":
                    {
                        this.props.SetToUScreen();
                    }
                    break;

                case "PYMTISSUE":
                    {
                        let failMsg = ConvToString(loginInfo.FailMsg);
                        this.props.showPaymentMsgTbl(failMsg);
                    }
                    break;
                case "FAILED":
                    {
                        let failMsg = ConvToString(loginInfo.FailMsg);
                        if (ConvToBool(loginInfo.PromptMsg)) {
                            this.setState({ ErrMsg: "" }, () => { toast(failMsg,{theme:'light',type:'info'}); });;
                        } else {
                            this.setState({ ErrMsg: failMsg });toast(failMsg,{theme:'light',type:'error'});
                        }
                    }
                    break;
                case "LOCSUBSCRIPTIONISSUE":
                    {
                        let failMsg = ConvToString(loginInfo.Warn);
                        this.props.showSubReminder(failMsg)

                        
                    }
                    break;
                default:
                    {
                        if (String(loginInfo.Warn || "").length > 0) {
                            toast(loginInfo.Warn,{type:'warn'});
                        }
                        this.state.ErrMsg = "";
						if(this.props.Screen.RegisterMFA)//Show message indicating MFA is registered successfully
                             toast('Your MFA device was registered successfully',{type:'success'});
                    }

            }
        }

    }


    showLoginDetailsWindow(loginInfo, cb) {
		var userRole = this.props.UserDetails.userRoleId;

        var disableLocationDropdownList = false;
        this.props.Screen.showLoginDiv = false;
        this.props.Screen.showProceedDiv = true;
        this.props.Screen.showNewPwdDiv = false;


        this.forceUpdate(() => this.handleRoleClick({ target: { value: "1" } }));
        if (userRole.toLowerCase() == 'global') {
            disableLocationDropdownList = true;
            this.setCompanyForGlobalUser();
        } else {
            this.setState({},
                () => {
                    this.setDefaultCompany(ConvToInt(this.props.UserDetails.defaultCompany));
                    this.setDefaultLocation(true, ConvToInt(this.props.UserDetails.defaultLocation));
                }
            );
        }


        this.setState({
            disableLocationDropdownList: disableLocationDropdownList
        }
            , () => {
                if (cb) cb();
                if (this.refs.cbRoles) this.refs.cbRoles.focus();
            });
    }
    setDefaultCompany(defCompany) {
        if (this.props.UserDetails.companyDtlList != null && this.props.UserDetails.companyDtlList.length > 0) {
            var userCompanyID = -1, userCompanyName = '';
            if (typeof (defCompany) == undefined || defCompany == null) defCompany = 0;
            if (this.props.UserDetails.companyDtlList.length > defCompany) {
                let compDtl = this.props.UserDetails.companyDtlList[defCompany];
                userCompanyID = compDtl.CompanyID;
                userCompanyName = compDtl.Name;
            }
            this.props.UserDetails.userCompanyID = userCompanyID;
            this.props.UserDetails.userCompanyName = userCompanyName;
            this.setState({});
        }
    }

    setDefaultLocation(setAsPerCookie, defLocation) {

        if (typeof (setAsPerCookie) == undefined || setAsPerCookie == null) setAsPerCookie = false;
        if (this.props.UserDetails.locationDtlList != null && this.props.UserDetails.locationDtlList.length > 0) {

            if (typeof (defLocation) == undefined || defLocation == null) defLocation = 0;
            if (!setAsPerCookie) {
                defLocation = 0;
            }
            let locDtl = this.props.UserDetails.locationDtlList[defLocation];
            this.props.UserDetails.userLocationId = locDtl.LocationId;
            this.props.UserDetails.userLocationName = locDtl.Location;
            this.setState({});
        }
    }
    handleRoleClick(event) {
        switch (event.target.value) {
            case "1":
                this.props.UserDetails.UserRoleVal = 1;
                this.props.UserDetails.isSysAdmin = false;
                this.props.UserDetails.isBranchAdmin = true;
                this.setState({});
                break;
            case "2":
                this.props.UserDetails.UserRoleVal = 2;
                this.props.UserDetails.isSysAdmin = true;
                this.props.UserDetails.isBranchAdmin = false;
                this.setState({});
                break;
        }

    }
    setCompanyForGlobalUser() {

        this.props.UserDetails.companyDtlList = [{ Name: "GLOBAL", CompanyID: -1 }];
        this.setState({});

    }

    BuildParamAndCallProceed() {

        this.onProceedButtonClick(false);
    }
    promptForKillSession(logType, lastLoginSource) {

        if (lastLoginSource == "App")//if user is logged in from mobile app then we do not give option to kill the session.
        {
            toast('You have logged in using Mobile device. Logout from mobile device and try again.',{type:'error'});
            return;
        }

        if (confirm('You have logged in from another web portal,\nDo you want to kill the other session and continue?')) {

            switch (logType) {
                case 'proceed': this.onProceedButtonClick(true); break;
            }
        }
    }
}
